import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { getHostRedirectUrl } from "./hostRouting.tsx";
import { BrandingProvider } from "./components/BrandLogo.tsx";

const root = ReactDOM.createRoot(document.getElementById("root"));
const redirectUrl = getHostRedirectUrl(window.location.hostname);

if (redirectUrl) {
  window.location.replace(redirectUrl);
} else {
  root.render(
    // <React.StrictMode>
    <BrowserRouter>
      <BrandingProvider>
        <App />
      </BrandingProvider>
    </BrowserRouter>
    // </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
